module.exports = __webpack_public_path__ + "img/avatar.1d1fd2f3.png";